// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
require('./_set-collection-of')('WeakSet');



//////////////////
// WEBPACK FOOTER
// ./apps/guias/~/core-js/modules/es7.weak-set.of.js
// module id = 325
// module chunks = 0